import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { promiseTimeout } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import DesktopLayout from '~/core/layouts/Desktop.vue';
import MobileLayout from '~/core/layouts/Mobile.vue';
import { useAppLink, useSmartAppBannerSetup } from '~/core/composables';
import ResultsPlaceholder from '~/core/components/ResultsPlaceholer/ResultsPlaceholder.vue';
import BottomControlsButtons from '~/core/components/BottomControlsButtons/BottomControlsButtons.vue';
import { isDeeplinkOnlyPage } from '~/core/functions';
import EnvironmentBanner from '~/core/components/EnvironmentBanner/EnvironmentBanner.vue';
import useMainStore from '~/stores/useMainStore';
export default defineComponent({
  name: 'Default',
  components: {
    EnvironmentBanner: EnvironmentBanner,
    BottomControlsButtons: BottomControlsButtons,
    ResultsPlaceholder: ResultsPlaceholder,
    DesktopLayout: DesktopLayout,
    MobileLayout: MobileLayout
  },
  setup: function setup() {
    var mainStore = useMainStore();
    var _storeToRefs = storeToRefs(mainStore),
      overlaysCount = _storeToRefs.overlaysCount;
    useSmartAppBannerSetup();
    var _useNuxtApp = useNuxtApp(),
      $device = _useNuxtApp.$device,
      $vuetify = _useNuxtApp.$vuetify,
      $sentry = _useNuxtApp.$sentry;
    var $route = useRoute();
    var _useAppLink = useAppLink($route),
      storeLink = _useAppLink.storeLink,
      deepLink = _useAppLink.deepLink;
    var isDeeplinkOnly = computed(function () {
      return isDeeplinkOnlyPage($route, $device, $sentry);
    });
    var deeplinkOnlyPlaceholderTitle = computed(function () {
      var _$route$name, _$route$name2;
      if ((_$route$name = $route.name) !== null && _$route$name !== void 0 && _$route$name.startsWith('appointments')) {
        return 'Откройте приложение МедТочка, чтобы посмотреть детали записи';
      } else if ((_$route$name2 = $route.name) !== null && _$route$name2 !== void 0 && _$route$name2.startsWith('achievements')) {
        return 'Откройте приложение МедТочка, чтобы посмотреть награды';
      }
      return 'Откройте приложение МедТочка, чтобы посмотреть документ';
    });
    var isDesktopLayoutActive = computed(function () {
      return !$device.isMobile && $route.fullPath.includes('authorization');
    });
    watch(overlaysCount, function (val) {
      document.documentElement.style.overflow = val > 0 ? 'hidden' : '';
      document.body.style.overflow = val > 0 ? 'hidden' : '';
      if ($device.isDesktop) {
        document.documentElement.style.paddingRight = val > 0 ? "".concat($vuetify.breakpoint.scrollBarWidth, "px") : '0';
      }
    });
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ($device.isMobile) {
              document.documentElement.classList.add('is-mobile');
            }
            setRealVH();
            window.addEventListener('resize', setRealVH);
            if (!isDeeplinkOnly.value) {
              _context.next = 14;
              break;
            }
            if ($device.isIos) {
              _context.next = 10;
              break;
            }
            location.href = deepLink.value;
            _context.next = 8;
            return promiseTimeout(1000);
          case 8:
            _context.next = 11;
            break;
          case 10:
            document.addEventListener('visibilitychange', function () {
              if (window.history.length > 1) {
                window.history.go(-1); // go back to previous page
              } else {
                window.close();
              }
            });
          case 11:
            if (!($device.userAgent.includes(' Mi ') || $device.userAgent.includes('MiuiBrowser'))) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return");
          case 13:
            location.href = storeLink.value;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUnmount(function () {
      window.removeEventListener('resize', setRealVH);
    });
    function setRealVH() {
      // https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html
      document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight / 100, "px"));
    }
    return {
      storeLink: storeLink,
      isDesktopLayoutActive: isDesktopLayoutActive,
      isDeeplinkOnly: isDeeplinkOnly,
      deeplinkOnlyPlaceholderTitle: deeplinkOnlyPlaceholderTitle
    };
  }
});